export default {
  rowsPerPageOptions: [10, 20, 30, 40, 50]
};
